module.exports = __webpack_public_path__ + "img/play-machine.01cd6174.png";